import { observable, action, untracked, computed, isObservable, toJS } from 'mobx'
import { useEffect, useState } from 'react'
import { getSnapshot } from '@invisr/mobx-state-tree'
import { useComponentContext } from '../utils/renderer/Context'
import { cloneComponent } from '../utils/mst-utils'
import { useDebouncedProps, allProps } from './use-debounced-props'

export function useClonedComponent (component, item, index) {
  const ctx = useComponentContext()
  if (ctx.isConfig) {
    return useClonedForConfig(component, item, index)
  }

  return useCloned(component, item, index)
}

function useClonedForConfig (component, item, index) {
  const [newComponent] = useState(() => observable({
    item,
    index,
    component,
    get props () {
      const comps = this.component.getAllComponents().map(c => c.id)
      return Object.keys(allProps).filter(k => comps.includes(k)).map(k => allProps[k])
    },
    get toProps () {
      return { item: this.item }
    },
    get cloned () {
      this.component
      this.item
      this.index
      getSnapshot(this.component)
      this.props
      return untracked(() => cloneComponent(this.component, this))
    }
  }, {
    item: observable.struct,
    index: observable,
    component: observable.ref,
    cloned: computed,
    toProps: computed,
    snapshot: computed.struct
  }))

  const comp = newComponent.cloned
  useDebouncedProps(comp)

  useEffect(action(() => {
    newComponent.component = component
    newComponent.index = index
    newComponent.item = item
  }), [index, item])

  return comp
}

function useCloned (component, inItem, index) {
  const item = isObservable(inItem) ? toJS(inItem) : inItem
  const [props] = useState(() => observable({
    item,
    index,
    get toProps () {
      return { item: this.item }
    }
  }, {
    item: observable.struct,
    index: observable,
    toProps: computed
  }))

  const [comp] = useState(() => untracked(() => cloneComponent(component, props)))

  useEffect(action(() => {
    props.index = index
    props.item = item
  }), [index, item])

  return comp
}
